import c from "@mapbox/mapbox-gl-draw";
import { PL_DEFAULT_SELECT as l, PL_DIRECT_SELECT as g } from "./index.es445.js";
import { isFabricObjOnTop as a } from "./index.es446.js";
const t = c.lib, s = c.modes.direct_select, o = { ...s };
o.clickNoTarget = function() {
  this.changeMode(l);
};
o.clickInactive = function(e, i) {
  t.doubleClickZoom.disable(this);
  const r = this.getSelectedIds(), n = i.featureTarget.properties.id;
  this.isSelected(n) || (r.forEach((d) => this.doRender(d)), this.setSelected(n), this.changeMode(g, { featureId: n })), this.doRender(n);
};
o.onDrag = function(e, i) {
  if (a(i) && !e.dragMoving)
    return this.clickNoTarget(e, i);
  if (e.canDragMove !== !0)
    return;
  e.dragMoving = !0, i.originalEvent.stopPropagation();
  const r = {
    lng: i.lngLat.lng - e.dragMoveLocation.lng,
    lat: i.lngLat.lat - e.dragMoveLocation.lat
  };
  e.selectedCoordPaths.length > 0 ? this.dragVertex(e, i, r) : this.dragFeature(e, i, r), e.dragMoveLocation = i.lngLat;
};
o.onClick = function(e, i) {
  if (a(i))
    return this.clickNoTarget(e, i);
  if (t.CommonSelectors.noTarget(i))
    return this.clickNoTarget(e, i);
  if (t.CommonSelectors.isInactiveFeature(i))
    return this.clickInactive(e, i);
  this.stopDragging(e);
};
o.onTap = function(e, i) {
  if (a(i))
    return this.clickNoTarget(e, i);
  if (t.CommonSelectors.noTarget(i))
    return this.clickNoTarget(e, i);
  if (t.CommonSelectors.isInactiveFeature(i))
    return this.clickInactive(e, i);
};
o.onTrash = function(e) {
  e.selectedCoordPaths.sort((i, r) => r.localeCompare(i, "en", { numeric: !0 })).forEach((i) => e.feature.removeCoordinate(i)), this.fireUpdate(), e.selectedCoordPaths = [], this.clearSelectedCoordinates(), this.fireActionable(e), e.feature.isValid() === !1 && (this.deleteFeature([e.featureId]), this.changeMode(l));
};
o.startDragging = function(e, i) {
  e.initialDragPanState = this.map.dragPan.isEnabled(), this.map.dragPan.disable(), e.canDragMove = !0, e.dragMoveLocation = i.lngLat;
};
o.stopDragging = function(e) {
  e.canDragMove && e.initialDragPanState === !0 && (this.map.dragPan.enable(), e.selectedCoordPaths = [], this.clearSelectedCoordinates(), e.feature.changed()), e.dragMoving = !1, e.canDragMove = !1, e.dragMoveLocation = null;
};
export {
  o as default
};
//# sourceMappingURL=index.es383.js.map
